import React from 'react'
import './checkout.css'
function checkout() {
  return (
    <h2>Thank you for Shopping with us</h2>
  )
}

export default checkout